import React from 'react';
import HamburgerMenu from '../ui/HamburgerMenu';

export const withHamburgerMenu = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  return (props: P) => {
    const currentPath = window.location.pathname;
    
    // Only hide menu on these specific pages
    const hideMenuPaths = [
      '/',          // Main page
      '/frame-123', // Legacy Categories
      '/frame-126', // Family History
      '/frame-129'  // Creative Works
    ];
    
    // Show menu on all pages except hideMenuPaths
    const showMenu = !hideMenuPaths.includes(currentPath);

    return (
      <div className="relative w-full">
        {showMenu && (
          <div className="fixed top-24 right-16 z-50">
            <HamburgerMenu />
          </div>
        )}
        <WrappedComponent {...props} />
      </div>
    );
  };
};

export default withHamburgerMenu;
